import { render, staticRenderFns } from "./TabPhones.vue?vue&type=template&id=67a7b7dc&scoped=true"
import script from "./TabPhones.vue?vue&type=script&lang=ts"
export * from "./TabPhones.vue?vue&type=script&lang=ts"
import style0 from "./TabPhones.vue?vue&type=style&index=0&id=67a7b7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a7b7dc",
  null
  
)

export default component.exports